<p-card class="policy-component">
  <div class="p-card-header flex p-3 gap-2 align-items-center">
    <p-select [options]="documentRequestGroups"
                optionLabel="name"
                [(ngModel)]="selectedDocumentRequestGroup"
                (onChange)="onRequestsSetChanged($event)">
    </p-select>
    <div class="flex align-items-center">
      <p-button [text]="true"
                icon="pi pi-plus"
                (click)="createDocumentRequestGroup()"></p-button>
      <p-button *ngIf="selectedDocumentRequestGroup"
                [text]="true"
                icon="pi pi-trash"
                severity="danger"
                [title]="'Delete Selected Request'"
                (click)="deleteDocumentRequestGroup()"></p-button>
      <div class="container-rlname">
        <input
          [(ngModel)]="selectedDocumentRequestGroup.name"
          pInputText
          class="form-control input-box"
          *ngIf="selectedDocumentRequestGroup"
          (input)="onInputRequestListName()"
          [ngClass]="{'highlight': highlightRequestListNameInput}"
        />
        <div class="message-box" [ngClass]="{'visible': messageForSetRequestListNameVisible}">
          Please update the name of the newly created request list.
        </div>
      </div>

      <p-button [text]="true"
                icon="pi pi-save"
                (click)="saveDocumentRequestGroup()"
                *ngIf="documentRequestGroups && documentRequestGroups.length != 0"></p-button>
    </div>
  </div>
  <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: start">
    <div style="display: flex; flex-direction: row;">
      <div *ngIf="selectedDocumentRequestGroup">
        <div style="display: flex; flex-direction: column;">
          <div style="width: 100%;">
            <p-table [value]="documentRequests" *ngIf="documentRequests"
                     dataKey="documentRequestId"
                     #documentRequestTbl
                     [columns]="cols"
                     resizableColumns="true"
                     columnResizeMode="fit">
              <ng-template pTemplate="caption">
                <div class="ui-helper-clearfix flex flex-row justify-content-end">
                  <button type="button"
                          (click)="edit()"
                          pButton
                          class="risksponge-button" icon="pi pi-plus"></button>
                  <button type="button"
                          pButton
                          class="risksponge-button"
                          icon="pi pi-file-excel"
                          iconPos="left"
                          (click)="documentRequestTbl.exportCSV()">
                  </button>
                  <p-button
                    [text]="true"
                    icon="pi pi-paperclip"
                    (click)="inputVendorFile.click()"
                  ></p-button>
                  <input #inputVendorFile
                         type="file"
                         (change)="import($event)"
                         [style.display]="'none'">

                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr style="white-space: nowrap;font-weight: bold">
                  <th [pSortableColumn]="'justification'">
                    Request ID
                    <p-sortIcon [field]="'justification'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'type'">
                    Type
                    <p-sortIcon [field]="'type'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'type'">
                    Controls
                    <p-sortIcon [field]="'type'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'description'" style="width:30%">
                    Description
                    <p-sortIcon [field]="'description'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'contact'">
                    Contact
                    <p-sortIcon [field]="'description'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th [pSortableColumn]="'requestDate'">
                    Requested
                    <p-sortIcon [field]="'requestDate'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th *ngIf="!isMaster">Attachments</th>
                  <th style='width: 10em;' *ngIf="!isMaster"></th>
                  <th style='width: 10em;' [pSortableColumn]="'accepted'" *ngIf="!isMaster">
                    Accepted
                    <p-sortIcon [field]="'accepted'" ariaLabel="Activate to sort"
                                ariaLabelDesc="Activate to sort in descending order"
                                ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                  </th>
                  <th style="width:15em"></th>
                </tr>
                <tr>
                  <ng-container *ngFor="let col of cols">
                    <th [ngSwitch]="col.field" pResizableColumn>
                      <input *ngSwitchDefault pInputText type="text" placeholder="⌕"
                             (input)="documentRequestTbl.filter($event.target['value'], col.field, 'contains')">
                    </th>
                  </ng-container>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr (dblclick)="edit(item)" *ngIf="!item.attachments.length">
                  <td>{{item.externalRequestId}}</td>
                  <td>
                    {{item.type}}
                  </td>
                  <td>
                    {{item.relatedControlsName}}
                  </td>
                  <td>{{item.description}}</td>
                  <td>{{item.contact}}</td>
                  <td>{{item.requestDate | date: 'shortDate'}}</td>
                  <td *ngIf="!isMaster">
                    <label [for]="'fileBlob' + item.documentRequestId" class="btn">
                      <i class="pi pi-plus"></i>
                      <input [id]="'fileBlob' + item.documentRequestId"
                             type="file"
                             (change)="AddAssessmentAttachment(item.documentRequestId, $event,item.externalRequestId)"
                             style="display: none;" />
                    </label>
                  </td>
                  <td *ngIf="!isMaster">
                  </td>
                  <td *ngIf="!isMaster">
                    <mat-checkbox [checked]="item.accepted"
                                  (change)="setIsAccepted(item.documentRequestId, $event.checked)"></mat-checkbox>
                  </td>
                  <td style="width: 5em;">
                    <i class="pi pi-pencil" (click)="edit(item)"></i>
                    <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Document Request'"
                       [popoverMessage]="'You are going to delete this document request. Are you sure?'"
                       [appendToBody]="true"
                       [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                       (confirm)="dropDocumentRequest(item)"></i>
                  </td>
                </tr>
                <ng-container *ngIf="item.attachments.length">
                  <tr *ngFor="let attachment of item.attachments; let attachmentRow = index">
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      {{item.externalRequestId}}
                    </td>
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      {{item.type}}
                    </td>
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      {{item.relatedControlsName}}
                    </td>
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      {{item.description}}
                    </td>
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      {{item.contact}}
                    </td>
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      {{item.requestDate | date: 'shortDate'}}
                    </td>
                    <td *ngIf="!isMaster">
                      <a (click)="DownloadAttachment(attachment.internalName, item)">{{attachment.name}}</a>
                      <label class="btn" [for]="'fileBlob' + item.documentRequestId" *ngIf="attachmentRow == (item.attachments.length - 1)">
                        <i class="pi pi-plus"></i>
                        <input [id]="'fileBlob' + item.documentRequestId"
                               type="file"
                               (change)="AddAssessmentAttachment(item.documentRequestId, $event,item.externalRequestId)"
                               style="display: none;" />
                      </label>
                    </td>
                    <td *ngIf="!isMaster">
                      <button type="button"
                              pButton
                              class="risksponge-button"
                              (click)="deleteDocumentRequestAttachment(attachment)"
                              icon="pi pi-trash">
                      </button>
                    </td>
                    <td [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="!isMaster && attachmentRow == 0">
                      <mat-checkbox [checked]="item.accepted"
                                    (change)="setIsAccepted(item.documentRequestId, $event.checked)"></mat-checkbox>
                    </td>
                    <td style="width: 5em;" [rowSpan]="item.attachments.length == 0 ? 1 : item.attachments.length"
                        *ngIf="attachmentRow == 0">
                      <i class="pi pi-pencil" (click)="edit(item)"></i>
                      <i class="pi pi-trash" mwlConfirmationPopover [title]="'Delete Document Request'"
                         [popoverMessage]="'You are going to delete this document request. Are you sure?'"
                         [appendToBody]="true"
                         [confirmText]="'Yes'" [cancelText]="'No'" placement="left"
                         (confirm)="dropDocumentRequest(item)"></i>
                    </td>
                  </tr>
                </ng-container>
              </ng-template>
            </p-table>

          </div>
        </div>
      </div>
    </div>
  </div>
</p-card>
